import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MobileTokenService {

    private token: string | null = null;
    private refreshToken: string | null = null;

    constructor() {
        this.initialize();
    }

    initialize(): void {

        // Verificar se está no navegador ANTES de acessar window
        if (typeof globalThis.window === 'undefined') {
            return;
        }

        const params = new URLSearchParams(globalThis.location.search);

        const token = params.get('token');
        const refresh = params.get('refreshToken');

        if (token) {

            this.token = token;
            this.refreshToken = refresh;

            sessionStorage.setItem('kc_token', token);

            if (refresh) {
                sessionStorage.setItem('kc_refresh_token', refresh);
            }

            globalThis.history.replaceState(
                {},
                document.title,
                globalThis.location.pathname
            );

        } else {

            this.token = sessionStorage.getItem('kc_token');
            this.refreshToken = sessionStorage.getItem('kc_refresh_token');
        }
    }


    getToken(): string | null {
        return this.token;
    }

    getRefreshToken(): string | null {
        return this.refreshToken;
    }

    isMobile(): boolean {
        return !!this.token;
    }

}
